import React from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { Button } from "@progress/kendo-react-buttons";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";

// Every prize line in the pot, with the two controls the administrator has over it.
//
// The original quantity sits under the total because the total moves and the original never does,
// so the pair together says how much was added after the pot was loaded.

const money = (value) =>
     new Intl.NumberFormat("en-GB", {
          style: "currency",
          currency: "GBP",
          maximumFractionDigits: 0,
     }).format(value || 0);

export default function LcvPrizePotGrid(props) {
     const { prizes, isBusy, onAvailabilityChange, onIncreaseQuantity } = props;

     return (
          <Grid data={prizes} className="sba-area-data-grid">
               <GridColumn field="displayName" title="Reward Description" width="260px" />
               <GridColumn
                    field="valueGbp"
                    title="Prize value"
                    width="110px"
                    cells={{
                         data: (cellProps) => <td>{money(cellProps.dataItem.valueGbp)}</td>,
                    }}
               />
               <GridColumn
                    field="totalQty"
                    title="Total prizes"
                    width="140px"
                    cells={{
                         data: (cellProps) => (
                              <td>
                                   {cellProps.dataItem.totalQty}
                                   {cellProps.dataItem.totalQty !== cellProps.dataItem.originalQty && (
                                        <Typography variant="caption" color="text.secondary" component="div">
                                             was {cellProps.dataItem.originalQty}
                                        </Typography>
                                   )}
                              </td>
                         ),
                    }}
               />
               <GridColumn field="wonQty" title="Won" width="90px" />
               <GridColumn field="remainingQty" title="Remaining" width="120px" />
               <GridColumn field="availableToWinQty" title="Available to play" width="160px" />
               <GridColumn
                    field="totalBudgetValueGbp"
                    title="Total Budget"
                    width="140px"
                    cells={{
                         data: (cellProps) => <td>{money(cellProps.dataItem.totalBudgetValueGbp)}</td>,
                    }}
               />
               <GridColumn
                    field="isAvailableToWin"
                    title="Available"
                    width="130px"
                    cells={{
                         data: (cellProps) => (
                              <td>
                                   <Switch
                                        checked={Boolean(cellProps.dataItem.isAvailableToWin)}
                                        disabled={isBusy}
                                        onChange={(event) =>
                                             onAvailabilityChange(cellProps.dataItem, event.target.checked)
                                        }
                                   />
                              </td>
                         ),
                    }}
               />
               <GridColumn
                    title="Stock"
                    width="150px"
                    cells={{
                         data: (cellProps) => (
                              <td>
                                   <Button
                                        type="button"
                                        disabled={isBusy}
                                        onClick={() => onIncreaseQuantity(cellProps.dataItem)}
                                   >
                                        Add stock
                                   </Button>
                              </td>
                         ),
                    }}
               />
          </Grid>
     );
}
